// @ts-nocheck
import React from 'react';
import { STATUS_COLORS, buildSimpleMetrics } from '@/utilities/callQualityRating';

export function QualityVerdict({ verdict, style }: any) {
  if (!verdict) return null;
  return (
    <div
      style={{
        border: `1px solid ${verdict.color}55`,
        borderLeft: `4px solid ${verdict.color}`,
        background: `${verdict.color}0f`,
        borderRadius: 10,
        padding: '10px 14px',
        ...style,
      }}
    >
      <div style={{ fontWeight: 700, fontSize: 14, color: verdict.color }}>
        {verdict.headline}
      </div>
      <div style={{ fontSize: 12, marginTop: 3, lineHeight: 1.45, opacity: 0.85 }}>
        {verdict.detail}
      </div>
    </div>
  );
}

export function QualityTile({ label, value, sub, desc, color, status }: any) {
  const tone = color || STATUS_COLORS.unknown;
  return (
    <div
      style={{
        flex: '1 1 190px',
        minWidth: 175,
        border: '1px solid #81818133',
        borderLeft: `3px solid ${tone}`,
        borderRadius: 10,
        padding: '10px 12px',
      }}
    >
      <div style={{ fontSize: 10, fontWeight: 700, textTransform: 'uppercase', opacity: 0.6 }}>
        {label}
      </div>
      <div style={{ fontSize: 20, fontWeight: 700, color: status === 'good' ? 'inherit' : tone }}>
        {value}
      </div>
      {sub ? <div style={{ fontSize: 10, opacity: 0.6 }}>{sub}</div> : null}
      {desc ? (
        <div style={{ fontSize: 11, opacity: 0.7, marginTop: 4, lineHeight: 1.35 }}>{desc}</div>
      ) : null}
    </div>
  );
}

export function QualityTiles({ source, style }: any) {
  const metrics = buildSimpleMetrics(source);
  if (!metrics.length) return null;
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, ...style }}>
      {metrics.map((m: any) => (
        <QualityTile key={m.key} {...m} />
      ))}
    </div>
  );
}

export default QualityTiles;
